
import { Tooltip } from "antd";
import clsx from "clsx";
import React, { useContext } from "react";
import { InfoCircleFilled } from "@ant-design/icons";
import { useSelector } from "react-redux";
import { formatNumber } from "src/utils/helper/functions";

type RedemHedgeDetailsProps = {
  fund: any;
  onBackClicked: () => void;
  setShowCashDetails: any;
  setShowAssetsDetails: any;
  setShowFundDetails: any;
  mode?: string;
};

const RedemHedgeDetails: React.FC<RedemHedgeDetailsProps> = ({
  fund,
  onBackClicked,
  setShowCashDetails,
  setShowAssetsDetails,
  setShowFundDetails,
  mode = "regular",
}: RedemHedgeDetailsProps): any => {

  return fund?.id ? (
    <div className="flex flex-col flex-grow">
      <div className=" p-4 bg-white rounded-xl shadow flex-col justify-start items-center gap-5 inline-flex">
        <div className="Frame427321142 self-stretch  flex-col justify-start items-start gap-10 flex">
          <div className="Frame576281 self-stretch  flex-col justify-start items-center gap-3 flex">
            <div className="Frame576049 self-stretch flex-col justify-start items-start gap-5 flex">
              <div className="Frame576329 self-stretch flex-col justify-start items-start gap-5 flex">
                <div className="items-center gap-2 inline-flex w-full">
                  <img
                    src="/images/arrow-right.svg"
                    className={clsx(
                      "cursor-pointer",
                      "rotate-180"
                    )}
                    width={24}
                    height={24}
                    alt="back"
                    onClick={() => {
                      onBackClicked();
                    }}
                  />
                  <div className=" flex grow text-[#2a2a2a] text-base font-bold">
                    Hedge Funds
                  </div>
                </div>
                <div className=" self-stretch flex-col justify-start items-start gap-3 flex">
                  <div className=" self-stretch p-3 bg-[#fdfdfd] rounded-lg border border-[#e3e3e3] flex-col justify-start items-start gap-6 flex">
                    <div className=" self-stretch  flex-col justify-start items-center gap-3 flex">
                      <div className=" self-stretch  flex-col justify-start items-start gap-4 flex">
                        <div className=" text-blue-500 text-[13px] font-semibold">
                          <div className="flex items-start gap-2">
                            {fund?.disclaimerText && (
                              <Tooltip
                                title={
                                  <ul>
                                    {fund?.disclaimerText
                                      ?.split("#")
                                      ?.map((ele: any, index: number) => (
                                        <li key={index}>{ele}</li>
                                      ))}
                                  </ul>
                                }
                              >
                                <InfoCircleFilled
                                  className="cursor-pointer"
                                  style={{ color: "#ffa500" }}
                                />
                              </Tooltip>
                            )}
                            {fund[`secNameEn`]}
                          </div>
                        </div>
                        <div className="Frame6209 self-stretch h-4 flex-col justify-start items-start gap-2 flex">
                          <div className="Frame6229 self-stretch justify-start items-start gap-2 inline-flex">
                            <div className="Frame6228 grow shrink basis-0 flex-col justify-start items-start gap-2 inline-flex">
                              <div className="Frame6261 self-stretch justify-between items-start inline-flex">
                                <div className="Frame6263 justify-start items-start gap-2 flex">
                                  <div className="Portfolio text-[#949494] text-[13px] font-semibold">
                                    Quantity
                                  </div>
                                </div>
                                <div className=" text-[#535353] text-[13px] font-semibold">
                                  {formatNumber(
                                    fund?.quantity,
                                    fund?.quantityDecimal
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        {fund?.reportingCurrency !==
                          fund?.investmentCurrency && (
                            <>
                              <div className="Rectangle9228 self-stretch h-0.5 bg-[#e3e3e3]" />
                              <div className="Frame6209 self-stretch h-4 flex-col justify-start items-start gap-2 flex">
                                <div className="Frame6229 self-stretch justify-start items-start gap-2 inline-flex">
                                  <div className="Frame6228 grow shrink basis-0 flex-col justify-start items-start gap-2 inline-flex">
                                    <div className="Frame6261 self-stretch justify-between items-start inline-flex">
                                      <div className="Frame6263 justify-start items-start gap-2 flex">
                                        <div className="Portfolio text-[#949494] text-[13px] font-semibold">
                                          Market value (
                                          {fund?.reportingCurrency}
                                          )
                                        </div>
                                      </div>
                                      <div className=" text-[#535353] text-[13px] font-semibold">
                                        {formatNumber(
                                          fund?.reportingMarketAmount,
                                          fund?.reportingCurrencyDcp
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </>
                          )}
                        <div className="Rectangle9228 self-stretch h-0.5 bg-[#e3e3e3]" />
                        <div className="Frame6209 self-stretch h-4 flex-col justify-start items-start gap-2 flex">
                          <div className="Frame6229 self-stretch justify-start items-start gap-2 inline-flex">
                            <div className="Frame6228 grow shrink basis-0 flex-col justify-start items-start gap-2 inline-flex">
                              <div className="Frame6261 self-stretch justify-between items-start inline-flex">
                                <div className="Frame6263 justify-start items-start gap-2 flex">
                                  <div className="Portfolio text-[#949494] text-[13px] font-semibold">
                                    market_value (
                                    {fund?.investmentCurrency}
                                    )
                                  </div>
                                </div>
                                <div className=" text-[#535353] text-[13px] font-semibold">
                                  {formatNumber(
                                    fund?.investmentMarketAmount,
                                    fund?.investmentCurrencyDcp
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="Rectangle9228 self-stretch h-0.5 bg-[#e3e3e3]" />
                        <div className="Frame6209 self-stretch h-4 flex-col justify-start items-start gap-2 flex">
                          <div className="Frame6229 self-stretch justify-start items-start gap-2 inline-flex">
                            <div className="Frame6228 grow shrink basis-0 flex-col justify-start items-start gap-2 inline-flex">
                              <div className="Frame6261 self-stretch justify-between items-start inline-flex">
                                <div className="Frame6263 justify-start items-start gap-2 flex">
                                  <div className="Portfolio text-[#949494] text-[13px] font-semibold">
                                    Avg. Cost
                                  </div>
                                </div>
                                <div className=" text-[#535353] text-[13px] font-semibold">
                                  {fund?.avarageCost
                                    ? formatNumber(fund?.avarageCost, 4)
                                    : "-"}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="Rectangle9228 self-stretch h-0.5 bg-[#e3e3e3]" />
                        <div className="Frame6218 self-stretch h-4 flex-col justify-start items-start gap-2 flex">
                          <div className="Frame6229 self-stretch justify-start items-start gap-2 inline-flex">
                            <div className="Frame6228 grow shrink basis-0 flex-col justify-start items-start gap-2 inline-flex">
                              <div className="Frame6261 self-stretch justify-between items-start inline-flex">
                                <div className="Frame6263 justify-start items-start gap-2 flex">
                                  <div className="  text-[#949494] text-[13px] font-semibold">
                                    NAV
                                  </div>
                                </div>
                                <div className="00000 text-[#535353] text-[13px] font-semibold">
                                  {fund?.portfolioMarketPrice
                                    ? formatNumber(
                                      fund?.portfolioMarketPrice,
                                      4
                                    )
                                    : "-"}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="Rectangle9237 self-stretch h-0.5 bg-[#e3e3e3]" />
                        <div className="Frame6210 self-stretch h-4 flex-col justify-start items-start gap-2 flex">
                          <div className="Frame6229 self-stretch justify-start items-start gap-2 inline-flex">
                            <div className="Frame6228 grow shrink basis-0 flex-col justify-start items-start gap-2 inline-flex">
                              <div className="Frame6261 self-stretch justify-between items-start inline-flex">
                                <div className="Frame6263 justify-start items-start gap-2 flex">
                                  <div className="Market text-[#949494] text-[13px] font-semibold">
                                    %Unreal. G/L
                                  </div>
                                </div>
                                <div
                                  className={clsx(
                                    " text-xs font-semibold",
                                    fund?.unrealPercentage >= 0
                                      ? "text-green-500"
                                      : "text-red-500"
                                  )}
                                >
                                  {fund?.unrealPercentage
                                    ? fund?.unrealPercentage > 0
                                      ? `${fund?.unrealPercentage}`
                                      : `(${Math.abs(fund?.unrealPercentage)})`
                                    : "-"}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="Rectangle9233 self-stretch h-0.5 bg-[#e3e3e3]" />
                        <div className="Frame6213 self-stretch h-4 flex-col justify-start items-start gap-2 flex">
                          <div className="Frame6229 self-stretch justify-start items-start gap-2 inline-flex">
                            <div className="Frame6228 grow shrink basis-0 flex-col justify-start items-start gap-2 inline-flex">
                              <div className="Frame6261 self-stretch justify-between items-start inline-flex">
                                <div className="Frame6263 justify-start items-start gap-2 flex">
                                  <div className="MarketValue text-[#949494] text-[13px] font-semibold">
                                    Ticker
                                  </div>
                                </div>
                                <div className="00000 text-[#535353] text-[13px] font-semibold">
                                  {fund?.internalRef?.trim() || "-"}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="Rectangle9229 self-stretch h-0.5 bg-[#e3e3e3]" />
                        <div className="Frame6211 self-stretch h-4 flex-col justify-start items-start gap-2 flex">
                          <div className="Frame6229 self-stretch justify-start items-start gap-2 inline-flex">
                            <div className="Frame6228 grow shrink basis-0 flex-col justify-start items-start gap-2 inline-flex">
                              <div className="Frame6261 self-stretch justify-between items-start inline-flex">
                                <div className="Frame6263 justify-start items-start gap-2 flex">
                                  <div className="Currency text-[#949494] text-[13px] font-semibold">
                                    Cost Value (
                                    {fund?.investmentCurrency}
                                    )
                                  </div>
                                </div>
                                <div className="Sar text-[#535353] text-[13px] font-semibold">
                                  {formatNumber(
                                    fund?.investmentCost,
                                    fund?.investmentCurrencyDcp
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="Rectangle9230 self-stretch h-0.5 bg-[#e3e3e3]" />
                        <div className="Frame6212 self-stretch h-4 flex-col justify-start items-start gap-2 flex">
                          <div className="Frame6229 self-stretch justify-start items-start gap-2 inline-flex">
                            <div className="Frame6228 grow shrink basis-0 flex-col justify-start items-start gap-2 inline-flex">
                              <div className="Frame6261 self-stretch justify-between items-start inline-flex">
                                <div className="Frame6263 justify-start items-start gap-2 flex">
                                  <div className="PLValue text-[#949494] text-[13px] font-semibold">
                                    Unreal. G/L Value (
                                    {fund?.investmentCurrency}
                                    )
                                  </div>
                                </div>
                                <div
                                  className={clsx(
                                    " text-xs font-semibold",
                                    fund?.investmentUnrealAmount >= 0
                                      ? "text-green-500"
                                      : "text-red-500"
                                  )}
                                >
                                  {fund?.investmentUnrealAmount
                                    ? formatNumber(
                                      fund?.investmentUnrealAmount,
                                      fund?.investmentCurrencyDcp
                                    )
                                    : "-"}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="Rectangle9232 self-stretch h-0.5 bg-[#e3e3e3]" />
                        <div className="Frame6217 self-stretch h-4 flex-col justify-start items-start gap-2 flex">
                          <div className="Frame6229 self-stretch justify-start items-start gap-2 inline-flex">
                            <div className="Frame6228 grow shrink basis-0 flex-col justify-start items-start gap-2 inline-flex">
                              <div className="Frame6261 self-stretch justify-between items-start inline-flex">
                                <div className="Frame6263 justify-start items-start gap-2 flex">
                                  <div className="PL text-[#949494] text-[13px] font-semibold">
                                    Holding %
                                  </div>
                                </div>
                                <div className="Sar text-[#535353] text-[13px] font-semibold">
                                  {formatNumber(
                                    fund?.totalPercentageFromPortfolio,
                                    2
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  ) : (
    ""
  );
};

export default RedemHedgeDetails;
